<script>
import {
  clientMethods,
  authComputed,
  authMethods,
  trainerMethods,
  clientComputed,
  adminPanelMethods,
} from '@state/helpers';
import { adminPanelMixin } from '@mixins/admin-panel-mixin';

export default {
  components: {},
  props: {},
  data() {
    return {
      avatar: require('@assets/images/placeholders/avatar.png'),
      imgPlaceHolder: require('@assets/images/placeholder-avatar.png'),
    };
  },
  mixins: [adminPanelMixin],
  computed: {
    ...authComputed,
    ...clientComputed,
  },
  beforeMount() {},
  mounted() {},
  methods: {
    ...trainerMethods,
    ...clientMethods,
    ...authMethods,
    ...adminPanelMethods,
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
    },
  },
};
</script>

<template>
  <div
    class="card-product-minimal"
    @click="showAdminPanel('ProductForm', null, 'md')"
  >
    <div class="card-product-details-wrapper">
      <div
        class="add-wrapper"
        @click="showAdminPanel('ProductForm', null, 'md')"
      >
        <BaseIcon class="icon-minus" name="plus" />
      </div>
      <span class="text-helper">Create New Product</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.add-wrapper {
  align-items: center;
  background-color: $color-action;
  border-radius: 50%;
  display: flex;
  height: 6rem;
  justify-content: center;
  margin-top: calc(10% + 1rem);
  width: 6rem;
  &:hover {
    background-color: $color-primary-thirteen;
    cursor: pointer;
  }

  .icon-minus,
  .icon-plus {
    color: white;
    height: 40%;
    width: 40%;
  }
}

.card-product-minimal {
  @include calc-font-size(2.3);

  background-color: white;
  border-radius: 8px;
  flex: 0 0 23%;
  height: 30vh;
  margin-bottom: 2%;
  margin-left: 0;
  margin-right: 2%;
  // margin: 2% 2% 0 0;
  max-height: 30vh;
  max-width: 23%;
  min-height: 28rem;
  transition: transform 300ms;
  transition-timing-function: ease-out;
  width: 22.1rem;
  &:hover {
    box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
    cursor: pointer;
    transform: scale(1.01);
  }
  .card-product-details-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 0.8rem;
    padding: 2rem;
    padding-right: 2rem;
    position: relative;
    .text-helper {
      color: $color-light-gray-eight;
      font-style: normal;
      font-weight: 900;
      line-height: 28px;
      margin-top: 2rem;
      text-align: center;
      width: 90%;
    }
  }
}
</style>
